import {
  GET_DESKRIPSI_BRIDAYA,
  GET_DETAIL_REKOMENDASI_BRIDAYA,
  GET_DETAIL_PEMBERDAYAAN_BRIDAYA,
  GET_LIST_REKOMENDASI_BRIDAYA,
  GET_LIST_TINDAK_LANJUT_BRIDAYA,
  GET_LIST_PEMBERDAYAAN_BRIDAYA,
  GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA,
  LOADING_GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA,
  INFINITE_SCROLL_REKOMENDASI_BRIDAYA,
  INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA,
  INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA,
  LOADING_INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA,
  LOADING_INFINITE_SCROLL_REKOMENDASI_BRIDAYA,
  LOADING_INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA,
  LOADING_DESKRIPSI_BRIDAYA,
  LOADING_GET_DETAIL_REKOMENDASI_BRIDAYA,
  LOADING_GET_DETAIL_PEMBERDAYAAN_BRIDAYA,
  LOADING_GET_LIST_REKOMENDASI_BRIDAYA,
  LOADING_GET_LIST_TINDAK_LANJUT_BRIDAYA,
  LOADING_GET_LIST_PEMBERDAYAAN_BRIDAYA,
  POST_SUBMIT_TL_AKAN_MENGUNJUNGI,
  LOADING_SUBMIT_TL_AKAN_MENGUNJUNGI,
  POST_SUBMIT_TL_TIDAK_MENGUNJUNGI,
  LOADING_SUBMIT_TL_TIDAK_MENGUNJUNGI,
  POST_SUBMIT_TL_TIDAK_TERTARIK,
  LOADING_SUBMIT_TL_TIDAK_TERTARIK,
  SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA,
  LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA,
  SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA,
  FINISH_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA,
  GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI,
  LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI,
  GET_LIST_ALASAN_TIDAK_COCOK,
  LOADING_GET_LIST_ALASAN_TIDAK_COCOK,
  POST_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI,
  LOADING_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI,
  POST_SUBMIT_TL_TIDAK_COCOK,
  LOADING_SUBMIT_TL_TIDAK_COCOK,
  POST_SUBMIT_TL_OTHER_CASE,
  LOADING_SUBMIT_TL_OTHER_CASE,
  POST_SUBMIT_TL_TK_TERTARIK,
  LOADING_SUBMIT_TL_TK_TERTARIK,
  POST_SUBMIT_TL_TK_OTHER_CASE,
  LOADING_SUBMIT_TL_TK_OTHER_CASE,
  GET_DETAIL_DITINDAKLANJUTI_BRIDAYA,
  LOADING_GET_DETAIL_DITINDAKLANJUTI_BRIDAYA,
  FINIS_POST_SUBMIT_TL_AKAN_MENGUNJUNGI,
  SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA,
  LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA,
  SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA,
  LOADING_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA,
  GET_LIST_USER_FILTER_BRIDAYA,
  LOADING_LIST_USER_FILTER_BRIDAYA
} from '../constants/bridaya';

const initialState = {
  listUserFilter: [],
  isLoadingUserFilter: true,
  listRekomendasiBridaya: { card: [] },
  listTindakLanjutBridaya: { card: [] },
  listPemberdayaanBridaya: { card: [] },
  listAlasanLolosPemberdayaan: [],
  detailRekomendasiBridaya: [],
  detailDitindaklanjutiBridaya: [],
  detailPemberdayaanBridaya: [],
  DeskripsiOnboardBridaya: [],
  submitTLTertarikAkanMengunjungi: [],
  submitTLTertarikTidakMengunjungi: [],
  submitTLTidakTertarik: [],
  submitLolosPemberdayaan1: [],
  submitTidakLolosPemberdayaan1: [],
  submitLolosPemberdayaan2: [],
  submitTidakLolosPemberdayaan2: [],
  submitTLTidakCocok: [],
  submitTLOtherCase: [],
  submitTLTidakDapatDihubungiTidakDikunjungi: [],
  submitTLLanjutanCase1: [],
  submitTLLanjutanOtherCase: [],
  listAlasanTidakDapatDihubungi: [],
  listAlasanTidakCocok: [],
  isLoadingDeskripsi: true,
  isLoadingListRekomendasi: true,
  isLoadingListTindakLanjut: true,
  isLoadingListPemberdayaan: true,
  isLoadingListAlasanLolosPemberdayaan: true,
  isLoadingDetailRekomendasiBridaya: true,
  isLoadingDetailDitindaklanjuti: true,
  isLoadingDetailPemberdayaanBridaya: false,
  isloadingInfiniteScrollBridaya: false,
  isloadingInfiniteScrollTindakLanjutBridaya: false,
  isloadingInfiniteScrollPemberdayaanBridaya: false,
  isloadingSubmitTLTertarikAkanMengunjungi: false,
  isloadingSubmitTLTertarikTidakMengunjungi: false,
  isloadingSubmitTLTidakTertarik: false,
  isLoadingsubmitLolosPemberdayaan1: true,
  isLoadingsubmitLolosPemberdayaan2: true,
  isLoadingsubmitTidakLolosPemberdayaan2: true,
  isSubmitTidakLolosPemberdayaan1: false,
  isAppearSncakbarBerhasilInputTL: false,
  isloadingSubmitTLTidakCocok: false,
  isloadingSubmitTLOtherCase: false,
  isloadingSubmitTLTidakDapatDihubungiTidakDikunjungi: false,
  isloadinglistAlasanTidakDapatDihubungi: true,
  isloadinglistAlasanTidakCocok: true,
  isLoadingSubmitTLLanjutanCase1: false,
  isLoadingSubmitTLLanjutanOtherCase: false,
};

export default function reducer(
  state = initialState,
  action = { type: '', payload: [] }
) {
  const { type, payload } = action;

  switch (type) {
    case GET_LIST_USER_FILTER_BRIDAYA:
      return {
        ...state,
        listUserFilter: payload,
        isLoadingUserFilter: false,
      };
    case LOADING_LIST_USER_FILTER_BRIDAYA:
      return {
        ...state,
        isLoadingUserFilter: true,
      };
    case GET_LIST_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        listRekomendasiBridaya: payload,
        isLoadingListRekomendasi: false,
      };
    case LOADING_GET_LIST_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        isLoadingListRekomendasi: true,
      };
    case GET_DETAIL_DITINDAKLANJUTI_BRIDAYA:
      return {
        ...state,
        detailDitindaklanjutiBridaya: payload,
        isLoadingDetailDitindaklanjuti: false,
        // isAppearSncakbarBerhasilInputTL: false
      };
    case LOADING_GET_DETAIL_DITINDAKLANJUTI_BRIDAYA:
      return {
        ...state,
        isLoadingDetailDitindaklanjuti: true,
      };
    case GET_LIST_TINDAK_LANJUT_BRIDAYA:
      return {
        ...state,
        listTindakLanjutBridaya: payload,
        isLoadingListTindakLanjut: false,
      };
    case LOADING_GET_LIST_TINDAK_LANJUT_BRIDAYA:
      return {
        ...state,
        isLoadingListTindakLanjut: true,
      };
    case GET_LIST_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        listPemberdayaanBridaya: payload,
        isLoadingListPemberdayaan: false,
      };
    case LOADING_GET_LIST_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        isLoadingListPemberdayaan: true,
      };
    case GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        listAlasanLolosPemberdayaan: payload,
        isLoadingListAlasanLolosPemberdayaan: false,
      };
    case LOADING_GET_LIST_ALASAN_LOLOS_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        isLoadingListAlasanLolosPemberdayaan: true,
      };
    case GET_DESKRIPSI_BRIDAYA:
      return {
        ...state,
        DeskripsiOnboardBridaya: payload,
        isLoadingDeskripsi: false,
      };
    case LOADING_DESKRIPSI_BRIDAYA:
      return {
        ...state,
        isLoadingDeskripsi: true,
      };
    case GET_DETAIL_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        detailRekomendasiBridaya: payload,
        isLoadingDetailRekomendasiBridaya: false,
      };
    case LOADING_GET_DETAIL_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        isLoadingDetailRekomendasiBridaya: true,
      };
    case GET_DETAIL_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        detailPemberdayaanBridaya: payload,
        isLoadingDetailPemberdayaanBridaya: false,
      };
    case LOADING_GET_DETAIL_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        isLoadingDetailPemberdayaanBridaya: true,
      };
    case INFINITE_SCROLL_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        listRekomendasiBridaya: {
          ...state.listRekomendasiBridaya,
          card: [...state.listRekomendasiBridaya.card, ...payload],
        },
        isloadingInfiniteScrollBridaya: false,
      };
    case LOADING_INFINITE_SCROLL_REKOMENDASI_BRIDAYA:
      return {
        ...state,
        isloadingInfiniteScrollBridaya: true,
      };
    case INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA:
      return {
        ...state,
        listTindakLanjutBridaya: {
          ...state.listTindakLanjutBridaya,
          card: [...state.listTindakLanjutBridaya.card, ...payload],
        },
        isloadingInfiniteScrollTindakLanjutBridaya: false,
      };
    case LOADING_INFINITE_SCROLL_TINDAKLANJUT_BRIDAYA:
      return {
        ...state,
        isloadingInfiniteScrollTindakLanjutBridaya: true,
      };
    case INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        listPemberdayaanBridaya: {
          ...state.listPemberdayaanBridaya,
          card: [...state.listPemberdayaanBridaya.card, ...payload],
        },
        isloadingInfiniteScrollPemberdayaanBridaya: false,
      };
    case LOADING_INFINITE_SCROLL_PEMBERDAYAAN_BRIDAYA:
      return {
        ...state,
        isloadingInfiniteScrollPemberdayaanBridaya: true,
      };
    case POST_SUBMIT_TL_AKAN_MENGUNJUNGI:
      return {
        ...state,
        submitTLTertarikAkanMengunjungi: payload,
        isloadingSubmitTLTertarikAkanMengunjungi: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case FINIS_POST_SUBMIT_TL_AKAN_MENGUNJUNGI:
      return {
        ...state,
        isAppearSncakbarBerhasilInputTL: false,
      };
    case LOADING_SUBMIT_TL_AKAN_MENGUNJUNGI:
      return {
        ...state,
        isloadingSubmitTLTertarikAkanMengunjungi: true,
      };
    case POST_SUBMIT_TL_TIDAK_MENGUNJUNGI:
      return {
        ...state,
        submitTLTertarikTidakMengunjungi: payload,
        isloadingSubmitTLTertarikTidakMengunjungi: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TIDAK_MENGUNJUNGI:
      return {
        ...state,
        isloadingSubmitTLTertarikTidakMengunjungi: true,
      };
    case POST_SUBMIT_TL_TIDAK_TERTARIK:
      return {
        ...state,
        submitTLTidakTertarik: payload,
        isloadingSubmitTLTidakTertarik: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TIDAK_TERTARIK:
      return {
        ...state,
        isloadingSubmitTLTidakTertarik: true,
      };
    case SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA:
      return {
        ...state,
        submitLolosPemberdayaan1: payload,
        isLoadingsubmitLolosPemberdayaan1: false,
      };
    case LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_1_BRIDAYA:
      return {
        ...state,
        isLoadingsubmitLolosPemberdayaan1: true,
      };
    case SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA:
      return {
        ...state,
        isSubmitTidakLolosPemberdayaan1: payload,
      };
    case FINISH_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_1_BRIDAYA:
      return {
        ...state,
        isSubmitTidakLolosPemberdayaan1: false,
      };
    case SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA:
      return {
        ...state,
        submitLolosPemberdayaan2: payload,
        isLoadingsubmitLolosPemberdayaan2: false,
      };
    case LOADING_SUBMIT_LOLOS_PEMBERDAYAAN_2_BRIDAYA:
      return {
        ...state,
        isLoadingsubmitLolosPemberdayaan2: true,
      };
    case SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA:
      return {
        ...state,
        isLoadingsubmitTidakLolosPemberdayaan2: payload,
      };
    case LOADING_SUBMIT_TIDAK_LOLOS_PEMBERDAYAAN_2_BRIDAYA:
      return {
        ...state,
        isLoadingsubmitTidakLolosPemberdayaan2: false,
      };
    case POST_SUBMIT_TL_TIDAK_COCOK:
      return {
        ...state,
        submitTLTidakCocok: payload,
        isloadingSubmitTLTidakCocok: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TIDAK_COCOK:
      return {
        ...state,
        isloadingSubmitTLTidakCocok: true,
      };
    case POST_SUBMIT_TL_OTHER_CASE:
      return {
        ...state,
        submitTLOtherCase: payload,
        isloadingSubmitTLOtherCase: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_OTHER_CASE:
      return {
        ...state,
        isloadingSubmitTLOtherCase: true,
      };
    case POST_SUBMIT_TL_TK_TERTARIK:
      return {
        ...state,
        submitTLLanjutanCase1: payload,
        isLoadingSubmitTLLanjutanCase1: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TK_TERTARIK:
      return {
        ...state,
        isLoadingSubmitTLLanjutanCase1: true,
      };
    case POST_SUBMIT_TL_TK_OTHER_CASE:
      return {
        ...state,
        submitTLLanjutanOtherCase: payload,
        isLoadingSubmitTLLanjutanOtherCase: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TK_OTHER_CASE:
      return {
        ...state,
        isLoadingSubmitTLLanjutanOtherCase: true,
      };
    case POST_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI:
      return {
        ...state,
        submitTLTidakDapatDihubungiTidakDikunjungi: payload,
        isloadingSubmitTLTidakDapatDihubungiTidakDikunjungi: false,
        isAppearSncakbarBerhasilInputTL: true,
      };
    case LOADING_SUBMIT_TL_TIDAK_DAPAT_DIHUBUNGI_TIDAK_DIKUNJUNGI:
      return {
        ...state,
        isloadingSubmitTLTidakDapatDihubungiTidakDikunjungi: true,
      };
    case GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI:
      return {
        ...state,
        listAlasanTidakDapatDihubungi: payload,
        isloadinglistAlasanTidakDapatDihubungi: false,
      };
    case LOADING_GET_LIST_ALASAN_TIDAK_DAPAT_DIHUBUNGI:
      return {
        ...state,
        isloadinglistAlasanTidakDapatDihubungi: true,
      };
    case GET_LIST_ALASAN_TIDAK_COCOK:
      return {
        ...state,
        listAlasanTidakCocok: payload,
        isloadinglistAlasanTidakCocok: false,
      };
    case LOADING_GET_LIST_ALASAN_TIDAK_COCOK:
      return {
        ...state,
        isloadinglistAlasanTidakCocok: true,
      };
    default:
      return state;
  }
}
